import { defineStore } from 'pinia'
import type Route from '@/types/Route.ts'

export const useRouteStore = defineStore('routeStore', {
  state: () => ({
    routes: new Map<number, Route>()
  }),
  getters: {
    findRouteById:
      (state) =>
      (id: number): Route | undefined => {
        return state.routes.get(id)
      },
    getRouteCount: (state): number => {
      return state.routes.size
    },
    getAllRoutes: (state): Route[] => {
      return Array.from(state.routes.values())
    },
    getNextRouteName: (state): string => {
      const existingNumbers = Array.from(state.routes.values())
        .map((r) => r.name.match(/^Route (\d+)$/))
        .filter((m): m is RegExpMatchArray => m !== null)
        .map((m) => parseInt(m[1]))
      const next = existingNumbers.length > 0 ? Math.max(...existingNumbers) + 1 : 1
      return `Route ${next}`
    }
  },
  actions: {
    updateRouteById(id: number, data: Route) {
      this.routes.set(id, data)
    },
    deleteRouteById(id: number) {
      if (this.routes.has(id)) {
        this.routes.delete(id)
      }
    }
  }
})